import { Dispatch, SetStateAction, createContext, useContext } from 'react';

import { HtmlEditor } from 'modules/graphql/types';
import noop, { NoOp } from 'utils/noop';
import { DragDropTemplateOption } from 'modules/templateEditor/common';

export enum SelectedContentEditorStep {
  SelectEditor = 'SelectEditor',
  SelectDragAndDropDefaultTemplate = 'SelectDragAndDropDefaultTemplate',
}

export interface SelectContentEditorContextState {
  dragAndDropTemplateOptions: DragDropTemplateOption[];
  getTemplates: NoOp;
  isLoadingTemplates: boolean;
  onSelectEditor: (editor: HtmlEditor, template?: string) => void;
  selectedContentEditorStep: SelectedContentEditorStep;
  setSelectedContentEditorStep: Dispatch<SetStateAction<SelectedContentEditorStep>>;
}

export const SelectContentEditorContext = createContext<SelectContentEditorContextState>({
  dragAndDropTemplateOptions: [],
  getTemplates: noop,
  isLoadingTemplates: false,
  onSelectEditor: noop,
  selectedContentEditorStep: SelectedContentEditorStep.SelectEditor,
  setSelectedContentEditorStep: noop,
});

export const useSelectContentEditorContext = () => useContext(SelectContentEditorContext);
